import React from 'react';
import {UncontrolledTooltip} from 'reactstrap';

const Tooltip = ({target, text, placement = 'right'}) => (
  <UncontrolledTooltip
    target={target}
    placement={placement}
    autohide={false}
    container='root'
  >
    {text}
  </UncontrolledTooltip>
);

export default Tooltip;
